import { useQuery } from '@tanstack/react-query';
import { getAgentPerformance } from '@/services/agentPerformanceService';

export const useAgentPerformance = (dateRange: string) => {
  return useQuery({
    queryKey: ['agent-performance', dateRange],
    queryFn: () => getAgentPerformance(dateRange),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};